import { useTranslation } from 'react-i18next';
import { LuArrowRightLeft } from 'react-icons/lu';

import useCallbackWithErrorHandler from '../../../../hooks/useCallbackWithErrorHandler.tsx';
import { HeaderButton } from '../../HeaderButton.tsx';
import { APICommunicator } from '~/api/APICommunicator.ts';
import { hardNavigate } from '~/utils/hardNavigate';

const ImpersonationRevoke = () => {
    const { t } = useTranslation();

    const onClick = useCallbackWithErrorHandler(async () => {
        await APICommunicator.revokeImpersonation();
        hardNavigate('/management/users');
    }, []);

    return (
        <HeaderButton onClick={onClick} iconLeft={<LuArrowRightLeft />}>
            {t('TOP_HEADER.REVOKE_IMPERSONATION')}
        </HeaderButton>
    );
};

export default ImpersonationRevoke;
